export default {
  'managerialRepeatedVehicles.form.filterByPlate': 'Filtrar por Placa',

  'managerialRepeatedVehicles.column.table.plate': 'Placa',
  'managerialRepeatedVehicles.column.table.owner': 'Proprietário',
  'managerialRepeatedVehicles.column.table.cpfAndCnpj': 'CPF/CNPJ',
  'managerialRepeatedVehicles.column.table.color': 'Cor',
};
